/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  Spin,
  Tabs,
} from 'antd';
// import makeTree from 'utils/makeTree';
import TabPane from 'antd/lib/tabs/TabPane';
import {
  getAreas,
  getCuentasContables,
  getEstadosGlobales,
  getTipoDeGasto,
} from 'api/catalogos';
import { checkToken } from 'api/utils';
import { ESTATUS_AUTORIZADO, TIPO_PRESUPUESTO_EGRESO } from 'utils/constants';
import { getFuncionesPresupuestales } from 'api/catalogos/funcionesPresupuestales';
// import { getClasificadoresObjetoGastoInternos } from 'api/catalogos/clasificadorObjetoGasto';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getClasificadoresObjetoGastoUnion } from 'api/configuraciones/clasificadorObjetoGasto';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import {
  obtenerRegistrosDe, URIconfiguracionesDeSegmentosPresupuestales,
  URIdestinoPresupuestal,
} from 'utils/URIsSac';
import { getClasificacionAdministrativa, getClasificacionFuncional, getClasificacionProgramatica } from 'api/catalogos/indexSAC';
import { getProgramasPresupuestales } from 'api/catalogos/ProgramaPresupuestal';
import { getProyectoPresupuestales } from 'api/catalogos/ProyectoPresupuestal';
import { getModelPermission } from 'utils/permission';
import ClavesPresupuestalesSAC, { clavesPresupuestalesPermission } from '../Administracion/ClavesPresupuestalesSAC';
import ClavesPresupuestalesDeEgresos from '../Administracion/ClavesPresupuestalesDeEgresos';
// import { URIconfiguracionesDeSegmentosPresupuestales } from './ConfiguracionDeSegmentos';

const ClavesPresupuestalesDeEgresosTabManager = ({ permission }) => {
  const firstTab = 'Claves Presupuestales';
  const [currentParentTabKey, setCurrentParentTabKey] = useState(firstTab);

  const [loading, setLoading] = useState(false);
  const [tablesData, setTablesData] = useState({});
  const [configurador, setConfigurador] = useState({});

  const [reLoad, setReload] = useState(false);

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        __ejercicioFiscal,
        __areas,
        __destinosPresupuestales,
        __programas,
        __proyectos,
        __funcionesPresupuestales,
        __clasificacionAdministrativa,
        __clasificacionFuncional,
        __clasificacionProgramatica,
        __cogs,
        __tiposDeGastos,
        __fuentesFinanciamientos,
        __tipoDeNominaEmpleado,
        __planDeCuentas,
        __catalogoCuentasContables,
        __estados,
      ] = await Promise.all([
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        obtenerRegistrosDe(URIdestinoPresupuestal),
        getProgramasPresupuestales(),
        getProyectoPresupuestales(),
        getFuncionesPresupuestales({ estados_globales: ESTATUS_AUTORIZADO }),
        getClasificacionAdministrativa(),
        getClasificacionFuncional(),
        getClasificacionProgramatica(),
        getClasificadoresObjetoGastoUnion(),
        getTipoDeGasto(),
        obtenerRegistrosDe('contabilidad/clasificaciones-de-fuentes-de-financiamiento-interna/'),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        obtenerRegistrosDe('catalogos/cuentas-contables-conac/'),
        getCuentasContables(),
        getEstadosGlobales(),
      ]);
      const _tablesData = {
        _ejercicioFiscal: __ejercicioFiscal,
        _areas: __areas,
        _destinosPresupuestales: __destinosPresupuestales,
        _programas: __programas,
        _proyectos: __proyectos,
        _funcionesPresupuestales: __funcionesPresupuestales,
        _clasificacionAdministrativa: __clasificacionAdministrativa,
        _clasificacionFuncional: __clasificacionFuncional,
        _clasificacionProgramatica: __clasificacionProgramatica,
        _cogs: __cogs,
        _tiposDeGastos: __tiposDeGastos,
        _fuentesFinanciamientos: __fuentesFinanciamientos,
        _tipoDeNominaEmpleado: __tipoDeNominaEmpleado,
        _planDeCuentas: __planDeCuentas,
        _catalogoCuentasContables: __catalogoCuentasContables,
        _estados: __estados,
      };
      const _configurador = await obtenerRegistrosDe(
        URIconfiguracionesDeSegmentosPresupuestales,
        {
          estados_globales: ESTATUS_AUTORIZADO,
          tipo_de_presupuesto: TIPO_PRESUPUESTO_EGRESO,
        },
      );
      setConfigurador(_configurador[0]);
      setTablesData(_tablesData);
      setLoading(false);
    };
    fetchAll();
  }, [reLoad]);

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          bordered={false}
        >
          <Tabs
            type="card"
            activeKey={currentParentTabKey || firstTab} // Evitar undefined
            onChange={setCurrentParentTabKey}
          >
            <TabPane
              tab={(
                <span>
                  {' '}
                  Claves Presupuestales
                </span>
              )}
              key={firstTab}
              forceRender
            >
              <ClavesPresupuestalesSAC
                egresoValues={tablesData}
                configurador={configurador}
                permission={getModelPermission(
                  clavesPresupuestalesPermission.permissionModel,
                )}
              />

            </TabPane>
            <TabPane
              tab={(
                <span>
                  Estructura
                </span>
              )}
              key="agregar"
              forceRender
            >
              <ClavesPresupuestalesDeEgresos
                defaultValues={tablesData}
                configurador={configurador}
                permission={permission}
                setReload={setReload}
              />
            </TabPane>
          </Tabs>
        </Card>
      </Spin>
    </Row>
  );
};

export default ClavesPresupuestalesDeEgresosTabManager;
